export default "__VITE_ASSET__KCkA0BpZ__"